import React from 'react';
import {
  Typography,
  Link,
  Container,
  styled,
} from '@material-ui/core';

import Button from '@/components/Button';
import GabrielTired from '@/assets/GabrielTired.svg';

export const ContentWrapper = styled('div')(({ theme }) => ({
  textAlign: 'center',
  paddingTop: theme.spacing(4),
}));

export const Img = styled('img')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 auto',
  paddingTop: theme.spacing(4),
}));

interface BaseErrorStateProps {
  title: string;
  subtitle?: string | React.ReactNode;
  supportEmail?: string;
  supportText?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const BaseErrorState: React.FC<BaseErrorStateProps> = ({
  title,
  subtitle,
  supportEmail,
  supportText,
  buttonText,
  onButtonClick,
  maxWidth = 'xs',
}) => {
  const renderSubtitle = () => {
    if (React.isValidElement(subtitle)) {
      return subtitle;
    }

    return (
      <Typography style={{ marginTop: 8, marginBottom: 32 }}>
        {subtitle}
        {supportEmail && supportText && (
          <Typography style={{ marginTop: 24 }} data-testid="support-info">
            {supportText}
            {' '}
            <Link
              href={`mailto:${supportEmail}`}
              underline="always"
              color="textPrimary"
            >
              {supportEmail}
            </Link>
          </Typography>
        )}
      </Typography>
    );
  };

  return (
    <Container maxWidth={maxWidth}>
      <Img alt="Gabriel Tired" style={{ width: '206px' }} src={GabrielTired} />
      <ContentWrapper>
        <Typography variant="h2">
          {title}
        </Typography>
        {renderSubtitle()}
        {buttonText && onButtonClick && (
          <Button
            variant="contained"
            type="button"
            fullWidth
            color="primary"
            onClick={onButtonClick}
            rounded
          >
            {buttonText}
          </Button>
        )}
      </ContentWrapper>
    </Container>
  );
};

export default BaseErrorState;
